package com.macrofocus.nastac.ui.layer

import js.objects.unsafeJso

fun createTooltip(): (Nothing) -> Any? {
    val tooltipFunction = { info: dynamic ->
        val `object` = info.`object`
        console.log("Click on ${info.`object`}")
        if (`object` != null) {
            if (info.layer.id.startsWith("pspm")) {
                val prob = info.`object`?.properties?.prob
                info.html = """
    <div style="
        text-align: center;
        padding-top: 6px;
    ">
        <h2 style="
            margin: 0;
            font-size: 1em;
            color: #333359;
        ">$prob</h2>
    </div>
""".trimIndent()
                info.style = unsafeJso<dynamic> {
                    backgroundColor = "rgba(255, 255, 255, 0.15)" // soft white background
                    this.color = "#333359"
                    fontSize = "0.85em"
                    borderRadius = "8px"
                    padding = "3px 6px 4px 6px"
                    boxShadow = "0 2px 6px rgba(0, 0, 0, 0.2)"   // subtle drop shadow
                    this.border = "1px solid rgba(200, 200, 255, 0.3)"
                    pointerEvents = "none"                       // so it doesn't interfere with hover
                    backdropFilter = "blur(3px)"                 // optional: glassy effect
                }
                info

            } else if (info.layer.id.startsWith("rshapes")) {
                val year = info.`object`?.properties?.year
                info.html = """
    <div style="
        text-align: center;
        padding-top: 6px;
    ">
        <h2 style="
            margin: 0;
            font-size: 1em;
            color: #333359;
        ">Railroad built in $year</h2>
    </div>
""".trimIndent()
                info.style = unsafeJso<dynamic> {
                    backgroundColor = "rgba(255, 255, 255, 0.15)" // soft white background
                    this.color = "#333359"
                    fontSize = "0.85em"
                    borderRadius = "8px"
                    padding = "3px 6px 4px 6px"
                    boxShadow = "0 2px 6px rgba(0, 0, 0, 0.2)"   // subtle drop shadow
                    this.border = "1px solid rgba(200, 200, 255, 0.3)"
                    pointerEvents = "none"                       // so it doesn't interfere with hover
                    backdropFilter = "blur(3px)"                 // optional: glassy effect
                }
                info

            } else if (info.layer.id.startsWith("geopolitics")) {
                val countryname = info.`object`?.properties?.countryname
                val lexclpop = info.`object`?.properties?.lexclpop
                info.html = """
    <div style="
        text-align: center;
        padding-top: 6px;
    ">
        <h2 style="
            margin: 0;
            font-size: 1em;
            color: #333359;
        ">$countryname: $lexclpop</h2>
    </div>
""".trimIndent()
                info.style = unsafeJso<dynamic> {
                    backgroundColor = "rgba(255, 255, 255, 0.15)" // soft white background
                    this.color = "#333359"
                    fontSize = "0.85em"
                    borderRadius = "8px"
                    padding = "3px 6px 4px 6px"
                    boxShadow = "0 2px 6px rgba(0, 0, 0, 0.2)"   // subtle drop shadow
                    this.border = "1px solid rgba(200, 200, 255, 0.3)"
                    pointerEvents = "none"                       // so it doesn't interfere with hover
                    backdropFilter = "blur(3px)"                 // optional: glassy effect
                }
                info

            } else if (info.layer.id.startsWith("heg")) {
                val EthnicName = (info.`object`?.properties?.EthnicName as? String)
                    ?.removeSuffix("[org]")       // removes the trailing "[org]" if present
                    ?.trim()                      // removes any leftover spaces
                    ?.replaceFirstChar { it.uppercase() }  // capitalizes the first letter
                info.html = """
    <div style="
        text-align: center;
        padding-top: 6px;
    ">
        <h2 style="
            margin: 0;
            font-size: 1em;
            color: #333359;
        ">$EthnicName</h2>
    </div>
""".trimIndent()
                info.style = unsafeJso<dynamic> {
                    backgroundColor = "rgba(255, 255, 255, 0.15)" // soft white background
                    this.color = "#333359"
                    fontSize = "0.85em"
                    borderRadius = "8px"
                    padding = "3px 6px 4px 6px"
                    boxShadow = "0 2px 6px rgba(0, 0, 0, 0.2)"   // subtle drop shadow
                    this.border = "1px solid rgba(200, 200, 255, 0.3)"
                    pointerEvents = "none"                       // so it doesn't interfere with hover
                    backdropFilter = "blur(3px)"                 // optional: glassy effect
                }
                info

            } else if (info.layer.id.startsWith("cshapes")) {
                val name = info.`object`?.properties?.Name
                info.html = """
    <div style="
        text-align: center;
        padding-top: 6px;
    ">
        <h2 style="
            margin: 0;
            font-size: 1em;
            color: #333359;
        ">$name</h2>
    </div>
""".trimIndent()
                info.style = unsafeJso<dynamic> {
                    backgroundColor = "rgba(255, 255, 255, 0.15)" // soft white background
                    this.color = "#333359"
                    fontSize = "0.85em"
                    borderRadius = "8px"
                    padding = "3px 6px 4px 6px"
                    boxShadow = "0 2px 6px rgba(0, 0, 0, 0.2)"   // subtle drop shadow
                    this.border = "1px solid rgba(200, 200, 255, 0.3)"
                    pointerEvents = "none"                       // so it doesn't interfere with hover
                    backdropFilter = "blur(3px)"                 // optional: glassy effect
                }
                info

            } else {
                null
            }

        } else {
            null
        }
    }

    return tooltipFunction
}